// filter.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, fieldNames?: string[]): any[] {
    if (!items || !items.length) return [];
    if (!searchText || !searchText.length) return items;
    
    searchText = searchText.toLowerCase();
    
    return items.filter(item => {
      if (fieldNames && fieldNames.length) {
        return fieldNames.some(field => {
          return item[field]?.toString().toLowerCase().includes(searchText);
        });
      }
      return JSON.stringify(item).toLowerCase().includes(searchText);
    });
  }
}